import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import '../../styles/SidebarItem';

let SidebarItem = React.createClass({
	displayName: 'SidebarItem',

	propTypes: {
		iconClass: PropTypes.string,
		isActive: PropTypes.bool,
		newTab: PropTypes.bool,
		onClick: PropTypes.func,
		targetUrl: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired
	},

	getClassName: function() {
		let className = 'sidebar-item';

		if (this.props.isActive) {
			className += ' active';
		}

		return className;
	},

	render: function() {
		const {
			newTab
		} = this.props;

		if (!newTab) {
			return (
				<Link
					className={ this.getClassName() }
					onClick={ (evt) => {
						if (this.props.onClick) {
							this.props.onClick(evt);
							evt.preventDefault();
						}
					} }
					to={ this.props.targetUrl }
				>
					{
						this.props.iconClass ? (
							<div className="sidebar-item-icon">
								<i className={ this.props.iconClass } />
							</div>
						) : ''
					}
					{ this.props.title }
				</Link>
			);
		}

		return (
			<a
				className={ this.getClassName() }
				href={ this.props.targetUrl }
				rel="noopener noreferrer"
				target="_blank"
			>
				{
					this.props.iconClass ? (
						<div className="sidebar-item-icon">
							<i className={ this.props.iconClass } />
						</div>
					) : ''
				}
				{ this.props.title }
			</a>
		);
	}
});

module.exports = SidebarItem;



// WEBPACK FOOTER //
// ./frontend/shared/js/components/SidebarItem.jsx